/**
 * Use this anywhere a default value needs to be shown to the user for missing or unavailable data.
 */
export const PLACEHOLDER_VALUE = '--';
